import React from 'react'
import { MinusIcon } from '@/atoms/Icons/MinusIcon'
import { PlusIcon } from '@/atoms/Icons/PlusIcon'
import { TitleMD } from '@/atoms/Text'

interface AccordionSectionProps {
  title: string
  icon: React.ReactNode
  isOpen: boolean
  onToggle: () => void
  children: React.ReactNode
}

export const AccordionSection: React.FC<AccordionSectionProps> = ({ title, icon, isOpen, onToggle, children }) => {
  return (
    <div className="mx-auto max-w-[750px] rounded-lg border border-core-gray-700 bg-core-gray-900">
      <button
        onClick={onToggle}
        className={`flex w-full items-center justify-between rounded-t-lg pb-2 pl-4 pr-6 pt-4 text-left transition-colors hover:bg-core-gray-700${
          !isOpen ? ' rounded-b-lg' : ''
        }`}
      >
        <div className="flex items-center gap-4">
          {icon}
          <TitleMD weight="bold" color="white">
            {title}
          </TitleMD>
        </div>
        {isOpen ? <MinusIcon size={24} color="white" /> : <PlusIcon size={24} color="white" />}
      </button>
      {isOpen && <div className="px-6 pb-6">{children}</div>}
    </div>
  )
}
